import React, { ChangeEvent, useEffect, useState } from 'react';
import classes from "./DCSelect.module.scss";

//Component properties interface
interface DCSelectProps {
    options: { [key: string]: string };
    value: string;
    required?: boolean;
    placeholder: string;   
    disable: boolean; 
    onInputChange: (event: ChangeEvent<HTMLSelectElement>) => void; // Add onInputChange event to props
    showErrorMsg:boolean;
    errMsg:string;
}

export const DCSelect = ({ options, value, required=true, placeholder,disable, onInputChange,showErrorMsg,errMsg }: DCSelectProps) => { // Destructure onInputChange from props
    const [inputValue, setInputValue] = useState<string>(value);
    
    // Update inputValue state when value prop changes
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleInputChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setInputValue(event.target.value);
        onInputChange(event); // Call onInputChange event
    };

    return (
        <div>
             <div className={`${classes.DCSelectInput} ${!showErrorMsg ? classes.DCSelectInputValid : classes.DCSelectInputNotValid}`}> 
            <div className={classes.DCSelectPlaceHolder}>{ required ? placeholder : `${placeholder} (optional)`  }</div>
                <select data-testid="dcSelectInput" value={inputValue} onChange={handleInputChange} disabled={disable}> {/* Use handleInputChange instead of onInputChange */}                   
                    {Object.entries(options).map(([key, value]) => (
                        <option key={key} value={key}>
                            {value}
                        </option>
                    ))}
                </select>
            </div>  
            {   !showErrorMsg ? null : 
                <div data-testid="dcSelectInputErrorMsg" className={classes.DCSelectInputErrorMessage}>
                  <span>{errMsg}</span></div>   }         
        </div>
    );
};

